import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-enhance.tsx
/**
* icon.24.enhance
*
* Keywords: hd, video, high-definition, quality, media, display, screen, television
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUuMDE1IDE0LjQzN2MuMTI2LS41MDUuODQ0LS41MDUuOTcgMGwuMzE1IDEuMjYgMS4yNi4zMTRjLjUwNS4xMjYuNTA1Ljg0NCAwIC45N2wtMS4yNi4zMTUtLjMxNCAxLjI2Yy0uMTI3LjUwNS0uODQ1LjUwNS0uOTcxIDBsLS4zMTQtMS4yNi0xLjI2LS4zMTVjLS41MDUtLjEyNi0uNTA1LS44NDQgMC0uOTdsMS4yNi0uMzE1ek0xNi45OTkgN2EyIDIgMCAwIDEgMiAydjZhMiAyIDAgMCAxLTEuNzk2IDEuOTlMMTcgMTdIOS41YS41LjUgMCAwIDEgMC0xSDE3YTEgMSAwIDAgMCAxLTFWOWExIDEgMCAwIDAtMS0xSDdhMSAxIDAgMCAwLTEgMXYzLjVhLjUuNSAwIDAgMS0xIDBWOWEyIDIgMCAwIDEgMi0yek0xMSAxMGEuNS41IDAgMCAxIC41LjV2M2EuNS41IDAgMCAxLTEgMHYtMUg5djFhLjUuNSAwIDAgMS0xIDB2LTNhLjUuNSAwIDAgMSAxIDB2MWgxLjV2LTFhLjUuNSAwIDAgMSAuNS0uNW0zIDBhMiAyIDAgMCAxIDAgNGgtMWEuNS41IDAgMCAxLS41LS41di0zYS41LjUgMCAwIDEgLjUtLjV6bS0uNSAzaC41YTEgMSAwIDAgMCAwLTJoLS41eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-7851
*/
const Icon24Enhance = memo(function Icon24Enhance(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.015 14.437c.126-.505.844-.505.97 0l.315 1.26 1.26.314c.505.126.505.844 0 .97l-1.26.315-.314 1.26c-.127.505-.845.505-.971 0l-.314-1.26-1.26-.315c-.505-.126-.505-.844 0-.97l1.26-.315zM16.999 7a2 2 0 0 1 2 2v6a2 2 0 0 1-1.796 1.99L17 17H9.5a.5.5 0 0 1 0-1H17a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.5a.5.5 0 0 1-1 0V9a2 2 0 0 1 2-2zM11 10a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-1H9v1a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0v1h1.5v-1a.5.5 0 0 1 .5-.5m3 0a2 2 0 0 1 0 4h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zm-.5 3h.5a1 1 0 0 0 0-2h-.5z"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.015 14.437c.126-.505.845-.505.97 0l.315 1.26 1.26.314c.505.126.505.844 0 .97l-1.26.315-.314 1.26c-.126.504-.844.504-.97 0l-.315-1.26-1.26-.315c-.505-.126-.505-.844 0-.97l1.26-.315zM16 7a2 2 0 0 1 2 2v6a2 2 0 0 1-1.796 1.99L16 17H9.5a.5.5 0 0 1 0-1H16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.5a.5.5 0 0 1-1 0V9a2 2 0 0 1 2-2zm-5.5 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-1H9v1a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0v1h1v-1a.5.5 0 0 1 .5-.5m3 0a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zm-.5 3h.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H13z"
		})
	});
});
//#endregion
export { Icon24Enhance };

//# sourceMappingURL=icon-24-enhance.js.map